import {
    get_tipiScadenzaMezzo,
    create_tipoScadenzaMezzo,
    update_tipoScadenzaMezzo,
    duplica_tipoScadenzaMezzo,
    delete_tipoScadenzaMezzo,
} from "@/api/api.tiposcadenzamezzo.js";

const tipiScadenzaMezzo = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_tipiScadenzaMezzo().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_tipoScadenzaMezzo(id, dati) : create_tipoScadenzaMezzo(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_tipoScadenzaMezzo(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                duplica_tipoScadenzaMezzo(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default tipiScadenzaMezzo;
